module.exports = __webpack_public_path__ + "img/headshot-1.017216a4.png";